import React from 'react'

import TextControl from '../text'

const TextAreaControl = props => <TextControl {...props} element="textarea" />

export default TextAreaControl
